//Production
export const API_URL = 'https://app.findpetapp.com/v2/';
export const PUBLIC_URL = 'https://app.findpetapp.com/';
export const FICHAS_URL = 'https://fichas.findpetapp.com/';
export const CARNET_URL = 'https://app.findpetapp.com/v2/ruf/';

//Development
// export const API_URL = 'https://dev.findpetapp.com/v2/';
// export const PUBLIC_URL = 'https://dev.findpetapp.com/';
// export const FICHAS_URL = 'https://fichas.findpetapp.com/';
// export const CARNET_URL = 'https://dev.findpetapp.com/v2/ruf/';

//Local
// export const API_URL = "http://127.0.0.1:8000/v2/";
// export const PUBLIC_URL = "http://127.0.0.1:8000/";
// export const FICHAS_URL = "https://fichas.findpetapp.com/";
// export const CARNET_URL = 'https://dev.findpetapp.com/v2/ruf/';
